import { Icon, IconButton, Stack, Title, Tooltip } from "@introist/react-foundation/v2";
import { List, ListRow } from "components/organisms/List";
import { api } from "services/rpc/RpcProvider";

interface FormShare {
  formId: string;
  responseId: string;
  submitted: boolean;
}

interface Props {
  formShares: FormShare[];
}

// Truncate string to max length with ellipsis
const truncateString = (str: string, maxLength: number = 25): string => {
  if (str.length <= maxLength) return str;
  return str.slice(0, maxLength) + "...";
};

export const FormShareViewer = ({ formShares }: Props) => {
  // Fetch all forms to get titles
  const { data: forms } = api.forms.v2.list.useQuery({});

  // Map form IDs to titles
  const getFormTitle = (formId: string) => {
    const form = forms?.find(f => f.id === formId);
    return form?.title ?? "Unknown Form";
  };

  return (
    <List>
      {formShares.map(formShare => {
        const fullTitle = getFormTitle(formShare.formId);
        const displayTitle = truncateString(fullTitle, 25);
        const isTruncated = fullTitle.length > 25;

        return (
          <ListRow key={formShare.formId} gridTemplateColumns="1fr auto auto">
            {/* Column 1: Form title */}
            {isTruncated ? (
              <Tooltip tooltip={fullTitle}>
                <Title variant="bold">{displayTitle}</Title>
              </Tooltip>
            ) : (
              <Title variant="bold">{displayTitle}</Title>
            )}

            {/* Column 2: Status */}
            {formShare.submitted ? (
              <Stack gap="xSmall">
                <Icon name="check" />
                <Title variant="bold">Completed</Title>
              </Stack>
            ) : (
              <Title>No submission</Title>
            )}

            {/* Column 3: Action button */}
            {formShare.submitted && (
              <IconButton
                size="small"
                variant="blended"
                icon="moveTo"
                onClick={() =>
                  window.open(
                    `/forms/${formShare.formId}/responses/${formShare.responseId}`,
                    "_blank"
                  )
                }
              />
            )}
          </ListRow>
        );
      })}
    </List>
  );
};
